import { __assign, __rest } from "tslib";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
var BiButton = function (_a) {
    var biData = _a.biData, innerRef = _a.innerRef, stopPropagation = _a.stopPropagation, disabled = _a.disabled, props = __rest(_a, ["biData", "innerRef", "stopPropagation", "disabled"]);
    var setTrackingRef = useBiClickLogger(biData, stopPropagation).setTrackingRef;
    return (React.createElement("button", __assign({ 
        /*
          Some screen readers don't pick up that a button is disabled
          when only `disable` is set, so use aria-disabled as well
        */
        disabled: disabled, "aria-disabled": disabled }, props, { ref: function (node) {
            setTrackingRef(node);
            innerRef && innerRef(node);
        } })));
};
BiButton.displayName = 'BiButton';
export default BiButton;
//# sourceMappingURL=BiButton.js.map